module.exports = __webpack_public_path__ + "img/loginLogo4.edc3b4fc.png";